import _ from 'lodash';
import template from './cardCjenik.html';

class CardCjenikController {
    constructor(DS, $scope) {
        this.store = DS;
        this.valute = _.castArray(this.valute);
        this.items = this.items || [];
        this.rows = [];
        $scope.$watch('vm.items', this.itemsChanged());
    };

    itemsChanged() {
        return (newValue, oldValue) => {
            var items = _.map(newValue, _.clone);
            this.rows = [];
            for (var i=0, j=items.length; i<j; i = i + 4) {
                this.rows.push(items.splice(0, 4));
            }
        };
    }

    getValutu(item) {
        return _.find(this.valute, (i) => i.id === item.valuta);
    }

    edit(item) {
        this.onEdit({item: item});
    }
}

const CardCjenikComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: CardCjenikController,
    controllerAs: 'vm',
    bindings: {
        items: '<',
        valute: '<',
        onEdit: '&'
    }
};

CardCjenikController.$inject = ['DS', '$scope'];
export {CardCjenikComponent};



// WEBPACK FOOTER //
// ./app/components/cjenik/cardCjenik.component.js